module.exports = __webpack_public_path__ + "static/screen-c4d5d16e60e8799508bc1b7708a05e2e.png";